import { Inject, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { Component } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';
import ScrapAgentService from '@/service/scrap-agent.service';

@Component({
  components: { DsModal },
})
export default class AccountNaverBlogMode extends Vue {
  @Prop({ type: Boolean, required: true }) open!: boolean;
  @Prop({ type: Object, default: () => ({}) }) userEdit!: any;
  @Prop({ type: Array, required: false }) sourceCacheList!: any;
  @Prop({ type: Array, required: false }) dataSourceSetting!: any;
  @PropSync('channelConnect', { type: Object }) syncedChannelConnect!: any;

  @Inject('scrapAgentService')
  public scrapAgentService: () => ScrapAgentService;
  showModal = this.open;
  isDisableBtn = true;
  formData = {
    profile: false,
    url: null,
    invalidUrl: false,
  } as any;
  @Watch('open')
  onOpenChange(value: boolean) {
    this.showModal = value;
    this.formData = {
      profile: false,
      url: null,
      invalidUrl: false,
    } as any;
    if (this.dataSourceSetting.length > 0 || this.sourceCacheList.length > 0) {
      console.log(this.sourceCacheList, 'sourceCacheList');
      const target = this.dataSourceSetting.find(item => item.accountId === this.userEdit.accountId && item.channelType === 'WORDPRESS');
      if (target && Array.isArray(target.collections)) {
        target.collections.forEach(collection => {
          if (Array.isArray(collection.datasourceList)) {
            collection.datasourceList.forEach(ds => {
              if (Array.isArray(ds.dataSourceTypes) && ds.dataSourceTypes.length > 0) {
                if (ds.dataSourceTypes[0] === 'MY_PROFILE') {
                  this.formData.profile = true;
                } else if (ds.dataSourceTypes[0] === 'URL') {
                  this.formData.url = ds.value[0];
                }
              }
            });
          }
        });
      }
      const matchedChannel = this.sourceCacheList.find(
        channel => channel.channelType === 'WORDPRESS' && channel.accounts?.[0]?.accountId === this.userEdit.accountId
      );

      if (matchedChannel) {
        const dataSources = matchedChannel.accounts[0].dataSource;
        dataSources.forEach(ds => {
          if (ds.dataSourceTypes[0] === 'MY_PROFILE') {
            this.formData.profile = true;
          } else if (ds.dataSourceTypes[0] === 'URL') {
            this.formData.url = ds.value[0];
          }
        });
      }
    } else {
      this.formData = {
        profile: false,
        url: null,
        invalidUrl: false,
      } as any;
    }
  }
  async handleSubmitChannel() {
    console.log(this.formData, 'this.formData');
    this.handleSignInSuccess().then(r => {});
  }
  async handleCloseModal() {
    this.$emit('modal:close');
    this.formData = {
      profile: false,
      url: null,
      invalidUrl: false,
    } as any;
  }
  @Watch('formData', { deep: true })
  onFormDataChange(value: any) {
    this.isDisableBtn = !this.formData.url && !this.formData.profile;
    const wordpressRegex = /^https:\/\//;
    if (value.url && value.url.trim() !== '') {
      if (!wordpressRegex.test(value.url.trim())) {
        this.formData.invalidUrl = true;
        this.isDisableBtn = true;
        return;
      } else {
        this.formData.invalidUrl = false;
      }
    } else {
      this.formData.invalidUrl = false;
    }
  }
  async handleSignInSuccess() {
    console.log(this.userEdit, 'this.userEdit');
    const value: any = {
      channelId: null,
      channelName: 'WordPress',
      channelDescription: this.formData.channelDescription || '',
      channelImageUri: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/wordpress.png',
      channelType: this.syncedChannelConnect.channelType,
      allowAccess: 'true',
      accounts: [
        {
          accountId: this.userEdit.accountId,
          accountName: this.userEdit.accountName || '-',
          dataSource: this.generateDataSources(this.formData),
          password: this.userEdit.password,
          isScrap: true,
        },
      ],
    };
    const accountIds = this.dataSourceSetting
      .filter(item => item.channelType === 'WORDPRESS' && item.accountId)
      .map(item => item.accountId);
    if (accountIds.includes(this.userEdit.accountId)) {
      this.$emit('addItemWordpress', value, true);
    } else {
      this.$emit('addItemWordpress', value, false);
    }
    this.formData = {
      profile: false,
      url: null,
      invalidUrl: false,
    } as any;
  }
  generateDataSources(data: any) {
    const dataSources: any = [];
    if (data.url) {
      dataSources.push({
        dataSourceTypes: ['URL'],
        value: [data.url],
      });
    }
    if (data.profile) {
      dataSources.push({
        dataSourceTypes: ['MY_PROFILE'],
        value: null,
        descriptionEn: 'My Profile',
      });
    }
    return dataSources;
  }
}
